import { render, staticRenderFns } from "./AboutSwiper6.vue?vue&type=template&id=52579937&scoped=true&"
import script from "./AboutSwiper6.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper6.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper6.vue?vue&type=style&index=0&id=52579937&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52579937",
  null
  
)

export default component.exports